import React from "react";
import AcquireWebComponent from "../../framework/MaterialUI";
import InsightNavigation from "../InsightNav";
import SiteDateSelector from "../SiteDateSelector";
import { isEmpty, find, isUndefined, isNil } from "lodash";
import { Row, Col, FullRow } from "../../framework/Grid/";
import "rc-tooltip/assets/bootstrap_white.css";
import Select from "react-select";
import "./tags.css";
import WebTagsTable from "./WebTagsTable";
import EmailTagsTable from "./EmailTagsTable";
import EmailTagDetail from "./EmailTagDetail";
import HtmlTagDetail from "./HtmlTagDetail";
import TagCreation from "./TagCreation";

class TagIndex extends AcquireWebComponent {
  componentWillMount() {
    this.state = {
      clientName: "",
      buName: "",
      clientId: undefined,
      tag_type: "Web",
      filter_tag_type: "Web",
    };
  }

  componentDidMount() {
    this.props.clearInsightTagInfo();
    this.props.clearTagError();
    if (this.props.selected_client && this.props.selected_client > 1) {
      this.props.getClientSites(this.props.selected_client);
      this.props.getClientTags(this.props.selected_client);
    }
  }

  componentWillReceiveProps(nextProps) {
    if (nextProps.selected_client !== this.props.selected_client) {
      if (nextProps.selected_client > 1) {
        this.props.getClientSites(nextProps.selected_client);
        this.props.getClientTags(nextProps.selected_client);
      }
    }
    if (nextProps.tag_info && isUndefined(this.props.tag_info)) {
      let clientName = nextProps.client_info ? nextProps.client_info.name : "";
      let buName = "";
      if (nextProps.client_info && nextProps.client_info.parentClientId) {
        buName = nextProps.client_info.name;
        const c = find(nextProps.clients, c => {
          return c.id === nextProps.client_info.parentClientId;
        });
        clientName = c ? c.name : "";
      }
      this.setState({
        clientName: clientName,
        buName: buName,
      });
    }
  }

  backToListClick(e) {
    e.preventDefault();
    const { client_info } = this.props;
    this.props.clearInsightTagInfoAndRefreh(client_info.id);
  }

  clickCreateTag(e) {
    e.preventDefault();
    this.props.createNewTag();
  }

  tagDetailContent(type) {
    return (
      <HtmlTagDetail
        type={type}
        clientName={this.state.clientName}
        buName={this.state.buName}
        imgTagName={this.state.imgTagName}
        backToListClick={this.backToListClick.bind(this)}
        {...this.props}
      />
    );
  }

  handleFilterTagTypeChanged(e) {
    this.setState({
      filter_tag_type: e.value,
    });
  }

  getContent() {
    const { match, clients, client_info, tag_info } = this.props;
    const showCreateTagBtn = this.props.roleId < 53 && this.props.roleId !== 5;
    const tagDevOptions = [
      { value: "Web", label: "Web Property" },
      {
        value: "Email",
        label: "HTML Email",
      } /*,
			{ value: 'Mobile', label: 'Year to date' }*/,
    ];
    switch (match.params.action) {
      case "detail":
        if (!isUndefined(tag_info)) {
          if (tag_info.deploymentType === "Web")
            return this.tagDetailContent("detail");
          else
            return (
              <EmailTagDetail
                clientName={this.state.clientName}
                buName={this.state.buName}
                type={"detail"}
                backToListClick={this.backToListClick.bind(this)}
                {...this.props}
              />
            );
        }
        this.props.history.push("/insights/tags/list");
        break;
      case "create":
        let clientName = client_info ? client_info.name : "";
        let buName = "";
        if (client_info && client_info.parentClientId) {
          buName = client_info.name;
          const c = find(clients, c => {
            return c.id === client_info.parentClientId;
          });
          clientName = c ? c.name : "";
        }
        if (isNil(tag_info)) {
          return (
            <TagCreation
              clientName={clientName}
              buName={buName}
              tagDevOptions={tagDevOptions}
              tag_variables={[]}
              tag_vars_deploy={"unique"}
              pass_variables={[]}
              hash_format={[]}
              hash_case={"upper"}
              {...this.props}
            />
          );
        } else {
          if (tag_info.deploymentType === "Web")
            return this.tagDetailContent("create");
          else
            return (
              <EmailTagDetail
                clientName={this.state.clientName}
                backToListClick={this.backToListClick.bind(this)}
                buName={this.state.buName}
                type={"create"}
                {...this.props}
              />
            );
        }
      default:
        return (
          <div className="website-visits-content">
            <Row className="no-padding mb-20 no-margin-top text-right">
              <Col xs="8" sm="8" md="8" lg="8" />
              <Col xs="4" sm="4" md="4" lg="4" className="text-right">
                {showCreateTagBtn && (
                  <button
                    type="button"
                    className="btn btn-default legitRipple btn-aa-default"
                  >
                    <a
                      onClick={e => {
                        this.clickCreateTag(e);
                      }}
                    >
                      GENERATE INSIGHTS TAG
                    </a>
                  </button>
                )}
              </Col>
            </Row>
            {isEmpty(this.props.client_tags) ? (
              <div
                className="black-border pb-10 text-center"
                style={{ minHeight: "200px", paddingTop: "80px" }}
              >
                <div
                  style={{ color: "#000", fontSize: "11pt", opacity: "0.8" }}
                >
                  No insights data currently available.
                </div>
              </div>
            ) : (
              <div
                className="black-border pb-20 pl-20 pr-20"
                style={{ background: "#fff", minHeight: "200px" }}
              >
                <h3
                  className="mt-20"
                  style={{ fontSize: "16px", fontWeight: "bold" }}
                >
                  TAGS
                </h3>
                <FullRow className="no-padding mb-20">
                  <span
                    style={{
                      fontWeight: "bold",
                      position: "absolute",
                      top: "10px",
                    }}
                  >
                    Tag Deployment Type
                  </span>
                  <span style={{ width: "180px", display: "inline-block" }}>
                    &nbsp;
                  </span>
                  <Select
                    value={this.state.filter_tag_type}
                    name=""
                    clearable={false}
                    options={tagDevOptions}
                    searchable={false}
                    onChange={this.handleFilterTagTypeChanged.bind(this)}
                  />
                </FullRow>
                {this.state.filter_tag_type === "Web" ? (
                  <WebTagsTable
                    client_tags={this.props.client_tags}
                    getTagDetail={this.props.getTagDetail}
                    client_info={this.props.client_info}
                  />
                ) : (
                  <EmailTagsTable
                    client_tags={this.props.client_tags}
                    getTagDetail={this.props.getTagDetail}
                    client_info={this.props.client_info}
                  />
                )}
              </div>
            )}
          </div>
        );
    }
  }

  render() {
    const { websiteId } = this.props;

    return (
      <div id="website-visits-container" style={{ background: "#fafafa" }}>
        <div
          style={{
            padding: "0 10%",
            marginTop: "-20px",
            marginBottom: "-10px",
            background: "#FAFAFA",
          }}
        >
          <SiteDateSelector
            key={"map-site-date-selector-" + new Date().getTime()}
            websiteIdChanged={this.props.setWebsiteId}
            siteId={websiteId}
            sites={this.props.client_sites}
            dayRangeChanged={this.props.setDateRange}
            dayRange={this.props.dayRange}
          />
        </div>
        <InsightNavigation
          activeIndex={4}
          clientId={this.props.selected_client}
          tagId={websiteId}
        />
        {this.getContent()}
      </div>
    );
  }
}

export default TagIndex;



// WEBPACK FOOTER //
// ./src/components/Insights/tags/index.jsx